import React, { Component } from 'react';
import { connect } from 'react-redux';
import TrailsApi from '../../../Logicas/TrailsApi';
import TrailsListCards from './TrailsListCards';

import * as S from './TrailsListStyles';

class TrailsList extends Component {
  componentDidMount() {
    const { page, available } = this.props;
    if (page === 1) {
      this.props.getTrails({ page, available });
    }
  }

  loadMore = () => {
    const { page, available, hasMore, loading } = this.props;

    if (loading || !hasMore) return;

    this.props.getTrails({
      page: page + 1,
      available
    });
  };

  render() {
    const { list, loading, hasMore } = this.props;

    return (
      <TrailsListCards
        cards={list}
        hasMore={hasMore}
        onScroll={this.loadMore}
        changeAvailableTrail={this.props.changeAvailableTrail}
        deleteTrail={this.props.deleteTrail}
        getCurrentTrail={this.props.getCurrentTrail}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  list: state.trails.list,
  page: state.trails.page,
  loading: state.trails.loading,
  hasMore: state.trails.hasMore
  // available: state.trails.available
});

const mapDispatchToProps = (dispatch) => ({
  getTrails: ({ page, available }) =>
    dispatch(TrailsApi.getTrails({ page, available }))
});

export default connect(mapStateToProps, mapDispatchToProps)(TrailsList);
